import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import { alpha } from '@mui/material/styles'

import { Icon, MerchantLogo, Text } from '@mxenabled/mxui'

import { useTheme } from '@mui/material/styles'

interface P2PCategorizationSingleAccountProps {
  amount?: string
  categorized?: string
  categoryGuid: string
  merchantGuid: string
  merchantName: string
  isSuccessState?: boolean
}

export const P2PCategorizationSingleAccount: React.FC<P2PCategorizationSingleAccountProps> = ({
  amount,
  categoryGuid,
  categorized,
  merchantGuid,
  merchantName,
  isSuccessState = false,
}) => {
  const theme = useTheme()

  const bgColor = theme.palette.mode === 'dark' ? 'grey.800' : 'grey.100'
  const background =
    'linear-gradient(256.82deg, rgba(255, 224, 153, 0.2) 1.86%, rgba(173, 248, 44, 0.2) 101.54%)'
  return (
    <Stack
      direction="row"
      sx={{
        bgcolor: bgColor,
        backgroundImage: isSuccessState === true ? background : undefined,
        p: 16,
        gap: 24,
      }}
    >
      <Box
        sx={{
          borderRadius: 1,
          boxShadow: `8px 6px 0 ${alpha(theme.palette.common.black, 0.75)}`,
        }}
      >
        <MerchantLogo
          alt={merchantName}
          border={1}
          borderColor="background.paper"
          categoryGuid={categoryGuid}
          merchantGuid={merchantGuid}
          size={64}
        />
      </Box>
      <Stack gap={1}>
        <Text variant="h2">{merchantName}</Text>
        {isSuccessState ? (
          <Stack
            alignItems="center"
            direction="row"
            gap={6}
            height={24}
            sx={{
              bgcolor: 'success.lighter',
              borderRadius: 5,
              border: '1px solid',
              borderColor: 'success.main',
              px: 16,
              py: 2,
            }}
          >
            <Icon color="success" fill={true} name="check_circle" size={16} />
            <Text color="success.dark" variant="subtitle2">
              {categorized}
            </Text>
          </Stack>
        ) : (
          <Text
            color="neutral.contrastText"
            sx={{ bgcolor: 'text.primary', px: 16, py: 2, borderRadius: 5 }}
            variant="subtitle2"
          >
            {amount}
          </Text>
        )}
      </Stack>
    </Stack>
  )
}
